import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={23.633}
    height="6.9mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 25430 28062"
    {...props}
  >
    <path
      d="M3983 26082c0-842 611-1313 1468-1313h9734c1405 0 1467 832 1467 1699H3983v-386zM2438 15885c-1158 0-1111-1700 0-1700 1083 0 1130 1700 0 1700zm18000-4017c-803 0-886-38-1545-386 143-214 2902-3077 3244-3168 1136 2148-636 3554-1699 3554zm-4790 772c-71-304-337-769-454-1091-665-1852-73-4366 1363-5802 798-797 2384-1604 3572-1604 1333 0 1995 34 3244 695-90 337-1532 1647-1873 1989-758 758-5475 5561-5852 5813zm-3631-9270c0-702 129-1214 821-1574 537-279 1118-205 1602 78 132 78 2064 1931 2135 2037-161 219-1314 859-2086 2318-520-349-921-806-1371-1256-407-407-1101-859-1101-1603zm-618 1931-7821 7783c-3451-1533-4694 3489-1640 4150 460 100 644 5 1004 35 142 11 443 567 545 734 464 758 3193 5062 3277 5376-1389 0-2021-106-2962 435-1295 745-1209 2120-1209 3349 0 319 259 696 541 696h14291c1119 0 632-2358 475-2794-473-1309-1604-1690-3102-1687-2111 5-4223 1-6334 1-1374-2052-2965-4921-4326-6954 696-510 546-1553 386-2240l7899-7938 1430 1390c-483 1048-377 2820-91 3954 173 686 379 1085 675 1642 142 267 290 462 452 707 759 1154 1286 33 2707-1205 142-124 136-145 292-249 1272 673 1018 772 2627 772 904 0 1932-613 2377-1099 1413-1538 1273-3282 172-4926 179-120 2163-1936 2163-2395 0-680-880-1073-1749-1495-1247-605-2147-591-3504-591-829 0-1413 307-2086 464-581-390-1245-1312-1842-1789-667-531-1180-1224-2484-1224-650 0-1277 287-1686 553-1191 774-1661 2449-943 3852 153 299 299 443 466 693z"
      style={{
        fill: "#000",
        // stroke: "#000",
        strokeWidth: 406.699,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
